import ReactDOM from 'react-dom/client';

import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary';
import { enableMapSet } from 'immer';
import { KfuseProvider } from 'monitoring';
import { loadUsetifulScript, setUsetifulTags } from 'usetiful-sdk';

import PhoenixProvider from '@yubi/phoenix-provider';
import { ToastProvider } from '@yubi/yb-core-snackbar-v3';
import StyleProvider from '@yubi/yb-style-provider';

import App from './App';
import './i18/I18';
import reportWebVitals from './reportWebVitals';

enableMapSet();

const env = process.env.REACT_APP_ENV || 'qa';
if (env === 'prd') {
  // REFERENCE: https://www.usetiful.com/install
  const REACT_APP_USETI_FUL_TOKEN = process.env.REACT_APP_USETI_FUL_TOKEN || '';
  loadUsetifulScript(REACT_APP_USETI_FUL_TOKEN);

  setUsetifulTags({
    userId: 'EXAMPLE_USER_ID', // This identifies the user and should be unique. Change it.
    firstName: 'EXAMPLE_FIRST_NAME', // This property defines user’s first name. Change it.
    lastName: 'EXAMPLE_LAST_NAME', // This property defines user’s last name. Change it.
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <KfuseProvider>
    <PhoenixProvider
      baseUrl={process.env.REACT_APP_PHOENIX_TOKENS_API_BASE_URL || ''}
    >
      <StyleProvider
        baseUrl={process.env.REACT_APP_PHOENIX_TOKENS_API_BASE_URL || ''}
      >
        <ToastProvider>
          <ErrorBoundary>
            <App />
          </ErrorBoundary>
        </ToastProvider>
      </StyleProvider>
    </PhoenixProvider>
  </KfuseProvider>
);

reportWebVitals();
